<template>
    <modal
        hideFoot
        :titleIcon="['far', 'chevron-left']"
        :type="'is-primary'"
        :size="'is-small'"
        :titleChange="handleClosed"
        title="Image Preview"
        @closed="handleClosed"
    >
        <div class="content">
            <div
                class="preview"
                :style="{
                    'background-image': `url(${sourceUrl})`
                }"
            />
        </div>
    </modal>
</template>

<script>

export default {
    props: {
        sourceUrl: { type: String, default: '' },
    },

    emits: ['close'],

    methods: {
        handleClosed() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    padding: 20px;
    .preview {
        width: 100%;
        height: 290px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 4px;
    }
}
</style>
